// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenCarbon_wrapper__2wk5T"};